import React, { forwardRef } from 'react';
import { ButtonBase, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const CustomButtonBase = styled(ButtonBase)(({ theme, variant }) => ({
    borderRadius: '24px',
    padding: theme.spacing(1, 2),
    borderStyle: 'solid',
    borderWidth: 1,
    ...(variant === 'light' && {
        "backgroundColor": alpha(theme.palette.background.neutral, 0.3),
        "borderColor": alpha(theme.palette.background.default, 0.3),
        "color": theme.palette.grey[50],
        '& .MuiTouchRipple-root .MuiTouchRipple-rippleVisible': {
            color: alpha(theme.palette.background.paper, 0.8)
        }
    }),
    ...(variant === 'dark' && {
        "backgroundColor": theme.palette.background.neutral,
        "borderColor": theme.palette.grey[200],
        "color": theme.palette.grey[200],
        '& .MuiTouchRipple-root .MuiTouchRipple-rippleVisible': {
            color: theme.palette.grey[400]
        }
    })
}));

const PrimaryButton = forwardRef(
    ({ variant = 'light', onClick, title, startIcon }, ref) => {
        return (
            <CustomButtonBase ref={ref} onClick={onClick} variant={variant} sx={{ gap: 0.5 }}>
                {startIcon && startIcon}
                {title && <Typography variant="button">{title}</Typography>}
            </CustomButtonBase>
        );
    }
);

PrimaryButton.propTypes = {
    variant: PropTypes.oneOf(['light', 'dark']),
    title: PropTypes.string,
    startIcon: PropTypes.element,
    onClick: PropTypes.func
};

export default PrimaryButton;
